var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 47,
    viewBox: "0 0 33 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3199 19.99C18.6064 19.99 20.4599 18.1364 20.4599 15.85C20.4599 13.5635 18.6064 11.71 16.3199 11.71C14.0335 11.71 12.1799 13.5635 12.1799 15.85C12.1799 18.1364 14.0335 19.99 16.3199 19.99Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.86 20.3999L5.44995 45.8299",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.77 20.3999L27.19 45.8299",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.79 25.7998H19.79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 32.7998H21.79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79004 39.7998H24.79",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50994 23.13C7.27615 21.626 6.49486 19.8026 6.257 17.872C6.01914 15.9413 6.3345 13.9828 7.16637 12.2244C7.99823 10.4659 9.3124 8.97993 10.9559 7.9393C12.5994 6.89866 14.5047 6.34619 16.4499 6.34619C18.3952 6.34619 20.3005 6.89866 21.944 7.9393C23.5875 8.97993 24.9016 10.4659 25.7335 12.2244C26.5654 13.9828 26.8807 15.9413 26.6429 17.872C26.405 19.8026 25.6237 21.626 24.3899 23.13",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75997 27.5899C3.54735 25.4658 2.01751 22.7308 1.36554 19.7337C0.713575 16.7366 0.969027 13.6132 2.09932 10.7619C3.22962 7.91057 5.18353 5.46049 7.7119 3.72411C10.2403 1.98773 13.2285 1.04374 16.2955 1.01252C19.3625 0.981295 22.3694 1.86425 24.9326 3.5488C27.4958 5.23334 29.4992 7.64313 30.6873 10.4709C31.8754 13.2986 32.1944 16.4161 31.6035 19.4258C31.0127 22.4356 29.5389 25.2012 27.37 27.3699",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.89,
    height: 46.83,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpLogoWhite);
export default __webpack_public_path__ + "static/media/cp-logo-white.f6d6695b46c0429b167e7042396c03b9.svg";
export { ForwardRef as ReactComponent };